import { NAME } from './constants';

export const BULK_UPDATE_ITEMS = `${NAME}/BULK_UPDATE_ITEMS`;
export const BULK_UPDATE_ITEMS_FAILURE = `${NAME}/BULK_UPDATE_ITEMS_FAILURE`;
export const BULK_UPDATE_ITEMS_SUCCESS = `${NAME}/BULK_UPDATE_ITEMS_SUCCESS`;

export const FETCH_FILTER_PROJECTS = `${NAME}/FETCH_FILTER_PROJECTS`;
export const FETCH_FILTER_PROJECTS_FAILURE = `${NAME}/FETCH_FILTER_PROJECTS_FAILURE`;
export const FETCH_FILTER_PROJECTS_SUCCESS = `${NAME}/FETCH_FILTER_PROJECTS_SUCCESS`;

export const FETCH_STATUS_PROJECT = `${NAME}/FETCH_STATUS_PROJECT`;
export const FETCH_STATUS_PROJECT_FAILURE = `${NAME}/FETCH_STATUS_PROJECT_FAILURE`;
export const FETCH_STATUS_PROJECT_SUCCESS = `${NAME}/FETCH_STATUS_PROJECT_SUCCESS`;

export const INITIALIZE = `${NAME}/INITIALIZE`;
export const INITIALIZE_SUCCESS = `${NAME}/INITIALIZE_SUCCESS`;
export const INITIALIZE_FAILURE = `${NAME}/INITIALIZE_FAILURE`;

export const RESET = `${NAME}/RESET`;

export const SAVE_PROJECT = `${NAME}/SAVE_PROJECT`;
export const SAVE_PROJECT_FAILURE = `${NAME}/SAVE_PROJECT_FAILURE`;
export const SAVE_PROJECT_SUCCESS = `${NAME}/SAVE_PROJECT_SUCCESS`;

export const SHOW_EMPTY_STATE = `${NAME}/SHOW_EMPTY_STATE`;

export const UPDATE_ITEMS_SUCCESS = `${NAME}/UPDATE_ITEMS_SUCCESS`;
